/*
 * @Author: Src
 * @Date: 2024-12-18 10:09:56
 * @LastEditTime: 2025-05-20 16:56:28
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/operationRoutes.ts
 * @Description: 品牌运营
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import StoreOperation from '@/views/operation/StoreOperation.vue';
import BatchManagement from '@/views/operation/BatchManagement.vue';
import StoreDetail from '@/views/operation/StoreDetail.vue';
import BatchShopList from '@/views/operation/BatchShopList.vue';
import { AuthEnum } from '@/services/permission.service';

const operationRoutes: RouteConfig = {
  name: 'operation',
  path: '/operation',
  component: Main,
  redirect: {
    name: 'operation.storeOperation',
  },
  meta: {
    title: '品牌运营',
  },
  children: [
    {
      name: 'operation.storeOperation',
      path: '/operation/storeOperation',
      component: StoreOperation,
      props: {
        auth: [AuthEnum.门店入驻列表],
      },
      meta: {
        title: '门店入驻审核',
      },
    },
    {
      name: 'operation.batchManagement',
      path: '/operation/batchManagement',
      component: BatchManagement,
      props: {
        auth: [AuthEnum.批次管理],
      },
      meta: {
        title: '批次管理',
      },
    },
    {
      name: 'operation.storeDetail',
      path: '/operation/storeDetail',
      component: StoreDetail,
      props: {
        auth: [AuthEnum.门店入驻列表],
      },
      meta: {
        title: '门店详情',
      },
    },
    {
      name: 'operation.batchShopList',
      path: '/operation/batchShopList/:batchNo',
      component: BatchShopList,
      props: {
        auth: [AuthEnum.批次管理],
      },
      meta: {
        title: '批次门店列表',
      },
    },
  ],
};

export default operationRoutes;
